import React, { Component, Fragment } from 'react';
import { Alert, Spinner, Table } from 'react-bootstrap';
import { groupSurveysByParent } from '../../Utils/groupSurveys';
import { getSurveyDisplayName } from '../../Utils/surveyDisplayName';
import { Form } from './Form';
import { DashboardDetails } from './DashboardDetails';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { SurveysAPI, MasterDataAPI } from "../../API";
import { exportToExcel } from "../../Utils/ExportToExcel";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import LanguageContext from "../../Layout/LanguageContext";
import { pageDict } from "../../Languages/PageTranslations";

const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
};

type State = {
    status: PageStatus,
    error: string | null,
    formType: string,
    data: any[],
    id?: string | null,
    filteredData: any[],
    filters: {
        dateRange: any,
        name: '',
        client: '',
        publishDate: '',
        expiryDate: '',
        surveyName: '',
        surveyType: '',
        id: '',
        uniqueid: '',
        projectname: '',
        pmName: '',
    },
    pageSize: any,
    currentPageNumber: any,
    loading: any,
    survey_unique_id: string,
    pmRespoOptions: any[],
    countryOpts: any[],
    expandedParents: any,
};

class DashboardSurveyComponent extends Component<any, any> {
    static contextType = LanguageContext;
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            formType: MODAL_TYPES.NONE,
            data: [],
            id: null,
            filteredData: [],
            filters: {
                dateRange: '',
                projectId: '',
                client: '',
                publishDate: '',
                expiryDate: '',
                surveyName: '',
                surveyType: '',
                country: '',
                uniqueid: '',
                projectname: '',
                pmName: '',
            },
            pageSize: 10,
            currentPageNumber: 1,
            totalResponseData: '',
            totalResponsePages: '',
            loading: false,
            survey_unique_id: '',
            pmRespoOptions: [],
            countryOpts: [],
            expandedParents: {},
        };
        this.fetchList = this.fetchList.bind(this);
    }

    toggleParent = (parentId: string) => {
        this.setState((prev) => ({
            expandedParents: {
                ...prev.expandedParents,
                [parentId]: !prev.expandedParents[parentId],
            },
        }));
    };

    componentDidMount() {
        this._isMounted = true;
        this.fetchList();
        this.fetchPmList();
        this.fetchCountryList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchPmList(): Promise<void> {
        return Promise.resolve()
            .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }) })
            .then(() => SurveysAPI.pmListAPI())
            .then((response) => {
                if (!this._isMounted) return;
                let pmRespo: any = response;
                let pmData = pmRespo.map((ele: any) => {
                    let value = "";
                    if (ele.basic_profile.firstName) {
                        value += ele.basic_profile.firstName += ele.basic_profile.lastName ? " " : "";
                    }
                    if (ele.basic_profile.lastName) {
                        value += ele.basic_profile.lastName;
                    }
                    return { label: value, value }
                });
                this.setState({ pmRespoOptions: pmData, status: PageStatus.Loaded });
            })
            .catch((error) => {
                if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    fetchCountryList(): Promise<void> {
        return Promise.resolve()
            .then(() => MasterDataAPI.countryList('10000'))
            .then((countries: any) => {
                if (!this._isMounted) return;
                const options = countries.map(country => ({
                    label: country.name,
                    value: country.name,
                }));
                this.setState({ countryOpts: options });
            })
            .catch(err => console.error("Failed to fetch country list", err));
    }

    fetchList(silent = false): Promise<void> {
        return Promise.resolve()
            .then(() => { if (this._isMounted && !silent) this.setState({ status: PageStatus.Loading }) })
            .then(() => SurveysAPI.getAll(this.state.pageSize, this.state.currentPageNumber, this.state.filters))
            .then((surveyData) => {
                if (!this._isMounted) return;
                let surveyRespoData: any = surveyData;
                this.setState({ data: surveyRespoData.data, filteredData: surveyRespoData.data, totalResponseData: surveyRespoData.totalCount, totalResponsePages: surveyRespoData.totalPage, status: PageStatus.Loaded });
            })
            .catch((error) => {
                if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    isShowDetailModal(): boolean {
        return this.state.formType === MODAL_TYPES.DETAILS
            || this.state.formType === MODAL_TYPES.DELETE;
    }


    handleFilterChange = (e) => {
        const { name, value } = e.target;
        this.setState(
            (prevState) => ({
                filters: {
                    ...prevState.filters,
                    [name]: value,
                },
            }),
        );
    };

    applyFilters = () => {
        const { publishDate, expiryDate } = this.state.filters;
        if (publishDate && expiryDate && new Date(expiryDate) < new Date(publishDate)) {
            Swal.fire({ icon: 'warning', title: 'Invalid Date Range', text: 'End date must be after start date.' });
            return;
        }
        if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
        this.setState({ currentPageNumber: 1 });
    };

    clearFilter = async () => {
        await new Promise((resolve: any) =>
            this.setState({
                filters: {
                    client: '',
                    publishDate: '',
                    projectId: '',
                    expiryDate: '',
                    surveyName: '',
                    surveyType: '',
                    dateRange: '',
                    country: '',
                    id: '',
                    uniqueid: '',
                    projectname: '',
                    pmName: '',
                },
                pageSize: 10,
                currentPageNumber: 1,
                totalResponseData: '',
                totalResponsePages: ''
            }, resolve))
        this.fetchList();
    }

    async handleExport() {
        const { currentPageNumber, filters } = this.state;
        this.setState({ loading: true });
        try {
            const recievedData = await SurveysAPI.getAll('All', currentPageNumber, filters);
            if (this._isMounted) exportToExcel(recievedData.data, 'surveys');
        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            if (this._isMounted) this.setState({ loading: false });
        }
    };
    handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
    handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

    componentDidUpdate(prevProps: any, prevState: State) {
        if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
        if (prevProps.selectedCountry !== this.props.selectedCountry) {
            this.setState({ currentPageNumber: 1 }, () => this.fetchList());
        }
    }

    handleStatusChangeFunc = async (e, id, survayEndDate) => {
        this.setState({ loading: true });
        try {
            if (!this.handleClickcheck(survayEndDate, e.target.value)) { return; }
            let payload = { surveyId: id, status: e.target.value }
            await SurveysAPI.updateSurveyStatusOnly(payload);
            if (this._isMounted) await this.fetchList();
        } catch (error) {
            console.error("Status change error:", error);
            if (this._isMounted) await this.fetchList();
        } finally {
            if (this._isMounted) this.setState({ loading: false });
        }
    }

    handleClickcheck = (data, paramStatus) => { // -----------------------------------------------------------------------------------------------
        const allModals = document.getElementsByClassName('fade modal show');
        if (paramStatus != "Open") { return true; }
        const changedExpireDate = data ? new Date(data) : null;
        const todayDate = new Date();
        const settingModalZIndex = (zIndex) => {
            Array.from(allModals).forEach(modal => {
                modal.style.zIndex = zIndex;
            });
        };
        if (changedExpireDate && changedExpireDate < todayDate) {
            settingModalZIndex('0');
            Swal.fire({
                icon: 'warning',
                title: 'Expired',
                text: 'The expiry date is in the past. Please correct the date',
            }).then(() => {
                settingModalZIndex('');
            });
            return false;
        } else {
            settingModalZIndex('');
            return true;
        }
    };

    render() {
        const { filters, pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
        const lang = this.context || 'en';
        const t = (key) => (pageDict[lang] && pageDict[lang][key]) || pageDict['en'][key] || key;
        const dropoutCalculationFunc = (totDropout, totHits) => {
            let calculatedValue = 0;
            if (totHits == 0) { return calculatedValue; }
            if (!isNaN(Number(totDropout)) && !isNaN(Number(totHits)))
                calculatedValue = ((Number(totDropout) / Number(totHits)) * 100).toFixed(2);
            return calculatedValue;
        }
        const aggregateChildrenStats = (children = [], parentRow: any = null) => {
            const sum = (key) => (Number(parentRow?.[key]) || 0) + children.reduce((a, c) => a + (Number(c?.[key]) || 0), 0);
            const completed_count = sum('completed_count');
            const terminated_count = sum('terminated_count');
            const over_quota_count = sum('over_quota_count');
            // PQ-split: quality_terminated_count is now post-survey QT (isPreScreenTerminated
            // IS NOT TRUE); pq_terminated_count is prescreener-fail QT (= TRUE). The two
            // children-sum keys exist on every child row returned by getAll's split queries.
            const quality_terminated_count = sum('quality_terminated_count');
            const pq_terminated_count = sum('pq_terminated_count');
            const verisoul_terminate_count = sum('verisoul_terminate_count');
            const totalhit_count = sum('totalhit_count');
            const dropout_count = sum('dropout_count');
            // Median LOI: completes-weighted average across parent + children (approximation)
            const parentCompletes = Number(parentRow?.completed_count) || 0;
            const parentLoiSum = parentCompletes * (Number(parentRow?.finalLOI) || 0);
            const childrenLoiSum = children.reduce(
                (a, c) => a + ((Number(c?.finalLOI) || 0) * (Number(c?.completed_count) || 0)),
                0
            );
            const finalLOI = completed_count > 0
                ? (parentLoiSum + childrenLoiSum) / completed_count
                : 0;
            return {
                completed_count,
                terminated_count,
                over_quota_count,
                quality_terminated_count,
                pq_terminated_count,
                verisoul_terminate_count,
                totalhit_count,
                dropout_count,
                finalLOI,
            };
        };
        return (
            <>
                <GridContainer>
                    <div className='w-100 mb-3'>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>{t("Dashboard")}</h4>
                            </div>
                        </CardHeader>
                    </div>
                </GridContainer>

                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <div className='mb-3'>{t("Survey Details")}</div>
                    <form>
                        <div className="row">
                            <div className="col">
                                <label htmlFor='publishDate'>{t("Start Date")}</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="select date"
                                    name="publishDate"
                                    value={filters.publishDate}
                                    onChange={this.handleFilterChange}

                                />
                            </div>
                            <div className="col">
                                <label htmlFor='pmName'>{t("PM Name")}</label>
                                <select
                                    style={{
                                        width: '100%',
                                        display: 'block',
                                        height: '40px',
                                        lineHeight: '1.5',
                                        color: '#495057',
                                        backgroundColor: '#fff',
                                        backgroundClip: 'padding-box',
                                        border: '1px solid #ced4da',
                                        borderRadius: '5px',
                                        transition:
                                            'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                                    }}
                                    name='pmName'
                                    id='pmName'
                                    value={filters.pmName}
                                    onChange={this.handleFilterChange}
                                >
                                    <option value=''>{t("--Choose--")}</option>
                                    {this.state.pmRespoOptions.length > 0 ? this.state.pmRespoOptions.map((item, index) => (
                                        <option key={"pmRespoOptions" + index} value={item.label}>{item.label}</option>
                                    )) : ''}
                                </select>
                            </div>
                            <div className="col">
                                <label htmlFor='expiryDate'>{t("End Date")}</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="select date"
                                    name="expiryDate"
                                    value={filters.expiryDate}
                                    min={filters.publishDate || undefined}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='surveyType'>{t("Type")}</label>
                                <select
                                    style={{
                                        width: '100%',
                                        display: 'block',
                                        height: '40px',
                                        lineHeight: '1.5',
                                        color: '#495057',
                                        backgroundColor: '#fff',
                                        backgroundClip: 'padding-box',
                                        border: '1px solid #ced4da',
                                        borderRadius: '5px',
                                        transition:
                                            'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                                    }}
                                    name='surveyType'
                                    id='type'
                                    required
                                    value={filters.surveyType}
                                    onChange={this.handleFilterChange}
                                >
                                    <option value='' disabled>{t("--Choose--")}</option>
                                    <option value='Test'>{t("Test")}</option>
                                    <option value='Hold'>{t("On Hold")}</option>
                                    <option value='Open'>{t("Live")}</option>
                                    <option value='Wait'>{t("Ids awaited")}</option>
                                    <option value='Close'>{t("End")}</option>
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor='projectname'>{t("Project Name")}</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder={t("Enter...")}
                                    name="projectname"
                                    value={filters.projectname}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='projectId'>{t("Project ID")}</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder={t("Enter...")}
                                    name="projectId"
                                    value={filters.projectId}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='client'>{t("Client Name")}</label>
                                <input type="text" name="client" className="form-control" placeholder={t("Enter...")} value={filters.client}
                                    onChange={this.handleFilterChange} />
                            </div>
                            <div className="col">
                                <label htmlFor='uniqueid'>{t("Survey Unique Id")}</label>
                                <input type="text" name="uniqueid" className="form-control" placeholder={t("Enter...")} value={filters.uniqueid}
                                    onChange={this.handleFilterChange} />
                            </div>
                            <div className="col">
                                <label htmlFor='country'>{t("Country")}</label>
                                <select
                                    style={{
                                        width: '100%',
                                        display: 'block',
                                        height: '40px',
                                        lineHeight: '1.5',
                                        color: '#495057',
                                        backgroundColor: '#fff',
                                        backgroundClip: 'padding-box',
                                        border: '1px solid #ced4da',
                                        borderRadius: '5px',
                                        transition:
                                            'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                                    }}
                                    name='country'
                                    id='country'
                                    value={filters.country}
                                    onChange={this.handleFilterChange}
                                >
                                    <option value=''>{t("--Choose--")}</option>
                                    {this.state.countryOpts && this.state.countryOpts.length > 0 ? this.state.countryOpts.map((item, index) => (
                                        <option key={"countryOpts" + index} value={item.value}>{item.label}</option>
                                    )) : ''}
                                </select>
                            </div>
                        </div>
                    </form>

                    <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
                        <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>{t("Filter Surveys")}</button>
                        <button type="button" className="btn btn-info ml-1" onClick={() => this.handleExport()}>{t("Export")}</button>
                        <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>{t("Clear Filter")}</button>
                    </div>


                </div>

                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                        {this.state.error}
                    </Alert>

                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded}>
                        <Show when={this.state.formType === MODAL_TYPES.CREATE}>
                            <Form
                                show={this.state.formType === MODAL_TYPES.CREATE}

                                onClose={() => this.setState({
                                    formType: MODAL_TYPES.NONE,
                                })}
                                onRefresh={() => this.fetchList(true)}
                                onSubmit={(id) => {
                                    this.fetchList(true);
                                    this.setState({
                                        formType: MODAL_TYPES.DETAILS, id: id,
                                    });
                                }}
                            />
                        </Show>

                        <Show when={!this.state.filteredData.length}>
                            <Alert variant="info" show={!this.state.filteredData.length}>
                                {t("No data is available")}
                            </Alert>
                        </Show>

                        <Show when={!!this.state.filteredData.length}>
                            <Show when={this.isShowDetailModal()}>
                                <DashboardDetails
                                    id={this.state.id}

                                    unique_id={this.state.survey_unique_id}

                                    onClose={() => {
                                        this.setState({
                                            formType: MODAL_TYPES.NONE,
                                            id: null,
                                        });
                                    }}
                                    onUpdate={(param, id) => {
                                        if (param == "clone") {
                                            this.fetchList(true);
                                            this.setState({ id });
                                            return;
                                        }
                                        this.setState({
                                            formType: MODAL_TYPES.UPDATE,
                                        });
                                    }}
                                    onDelete={(id) => {
                                        this.fetchList(true);
                                        this.setState({
                                            formType: MODAL_TYPES.NONE,
                                            id: null,
                                        });
                                    }}
                                />
                            </Show>

                            <Show when={this.state.formType === MODAL_TYPES.UPDATE}>
                                <Form
                                    show={this.state.formType === MODAL_TYPES.UPDATE}
                                    id={this.state.id}

                                    onClose={() => this.setState({
                                        formType: MODAL_TYPES.NONE,
                                        id: null,
                                    })}
                                    onRefresh={() => this.fetchList(true)}
                                    onSubmit={(id) => {
                                        this.fetchList(true);
                                        this.setState({
                                            formType: MODAL_TYPES.DETAILS, id: id,
                                        });
                                    }}
                                />
                            </Show>
                            <div className='mb-2'>
                                <ShowDataAccording2PageSize
                                    currentPageSize={pageSize}
                                    currentPage={currentPageNumber}
                                    sendPageSize={this.handlePageSizeChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                            </div>
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                                {this.state.loading && (
                                    <img style={{ height: "415px", }}
                                        src="../loadernew.gif"
                                        alt="Loading..."
                                    />
                                )}
                            </div>
                            <Table responsive size="sm" bordered>
                                <thead>
                                    <tr>
                                        {/* <th>S. No</th> */}
                                        <th>{t("Project Name")}</th>
                                        <th>{t("Project Id")}</th>
                                        <th>{t("Country")}</th>
                                        <th>{t("Survey Unique Id")}</th>
                                        <th>{t("Client")}</th>
                                        <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t("Status")}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                        <th>{t("PM")}</th>
                                        <th>{t("Client Quota")}</th>
                                        <th>{t("Complete")}</th>
                                        <th>{t("Terminate")}</th>
                                        <th>{t("Quotafull")}</th>
                                        <th>{t("Quality Terminate")}</th>
                                        <th>{t("PQ Terminated")}</th>
                                        <th>{t("Verisoul Blocked")}</th>
                                        <th>{t("Hits")}</th>
                                        <th>{t("Dropouts%")}</th>
                                        <th>{t("IR %")}</th>
                                        <th>{t("Median LOI")}</th>
                                        <th>{t("Start Date")}</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        groupSurveysByParent(this.state.filteredData).map((parent) => {
                                        const parentAggregates = parent.hasChildren ? aggregateChildrenStats(parent.children, parent) : null;
                                        const renderRow = (survey, isChild = false) => {
                                        const useAggregates = !isChild && parent.hasChildren && parentAggregates;
                                        const stats = useAggregates ? parentAggregates : survey;
                                        return (
                                            <tr key={survey.id} style={isChild ? { backgroundColor: '#f0f4f8' } : (parent.hasChildren ? { backgroundColor: '#f8f9fa' } : {})}>
                                                <td className="text-start" style={isChild ? { paddingLeft: '36px' } : {}}>
                                                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                        {!isChild && parent.hasChildren ? (
                                                            <span onClick={() => this.toggleParent(parent.id)} style={{ cursor: 'pointer', marginRight: '6px', display: 'inline-block', transition: 'transform 0.2s', transform: this.state.expandedParents[parent.id] ? 'rotate(90deg)' : 'rotate(0deg)', flexShrink: 0, marginTop: '2px' }}>&#9654;</span>
                                                        ) : isChild ? (
                                                            <span style={{ color: '#999', marginRight: '6px', flexShrink: 0 }}>&#9492;</span>
                                                        ) : (
                                                            <span style={{ display: 'inline-block', width: '16px', flexShrink: 0 }}></span>
                                                        )}
                                                        <button
                                                            type="button"
                                                            className="bg-transparent text-primary p-0 border-0 text-start d-block"
                                                            style={{ whiteSpace: "normal", ...(isChild ? { fontSize: '0.92em' } : {}) }}
                                                            onKeyPress={() => null}
                                                            onClick={() => {
                                                                this.setState({
                                                                    formType: MODAL_TYPES.DETAILS,
                                                                    id: survey.id,
                                                                    survey_unique_id: survey.uniqueid,
                                                                });
                                                            }}
                                                        >
                                                            <div
                                                                style={{ textAlign: "left", display: "block", whiteSpace: "normal" }}
                                                                dangerouslySetInnerHTML={{
                                                                    // One expression for both branches: getSurveyDisplayName
                                                                    // keys on the row's own parentid, so it covers children,
                                                                    // parents, and orphan children alike. `isChild` below is
                                                                    // still used for row styling/indent only.
                                                                    __html: getSurveyDisplayName(survey) || "Title",
                                                                }}
                                                            ></div>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>{survey?.projectId ?? "-"}</td>
                                                <td>{survey?.country ?? "-"}</td>
                                                <td>{survey?.uniqueid ?? "-"}</td>
                                                <td>{survey.client}</td>
                                                <td><div className="">
                                                    <select
                                                        style={{
                                                            width: '100%',
                                                            display: 'block',
                                                            height: '40px',
                                                            lineHeight: '1.5',
                                                            color: '#495057',
                                                            backgroundColor: '#fff',
                                                            backgroundClip: 'padding-box',
                                                            border: '1px solid #ced4da',
                                                            borderRadius: '5px',
                                                            transition:
                                                                'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                                                        }}
                                                        name='surveyType'
                                                        id='type'
                                                        required
                                                        value={survey.surveyType}
                                                        onChange={(e) => this.handleStatusChangeFunc(e, survey.id, survey.expiryDate)}
                                                    >
                                                        <option value='' disabled>--Choose--</option>
                                                        <option value='Test'>Test</option>
                                                        <option value='Hold'>On Hold</option>
                                                        <option value='Open'>Live</option>
                                                        <option value='Wait'>Ids awaited </option>
                                                        <option value='Close'>End</option>
                                                    </select>
                                                </div></td>
                                                <td>{survey.pmName}</td>
                                                <td>{survey.userLimitCommitted ?? "-"}</td>
                                                <td>{stats.completed_count}</td>
                                                <td>{stats.terminated_count}</td>
                                                <td>{stats.over_quota_count}</td>
                                                <td>{stats.quality_terminated_count}</td>
                                                <td>{stats.pq_terminated_count ?? 0}</td>
                                                <td>{stats.verisoul_terminate_count ?? 0}</td>
                                                <td>{stats.totalhit_count}</td>
                                                <td>{dropoutCalculationFunc(stats.dropout_count, stats.totalhit_count)}</td>
                                                <td>
                                                    {Number(stats.completed_count) + Number(stats.terminated_count) > 0
                                                        ? ((Number(stats.completed_count) / (Number(stats.completed_count) + Number(stats.terminated_count))) * 100).toFixed(2)
                                                        : '0.00'
                                                    }
                                                </td>
                                                <td>
                                                    {!isNaN(stats.finalLOI) && stats.finalLOI !== null ? Number(stats.finalLOI).toFixed(2) : '0.00'}
                                                </td>
                                                <td>{moment(survey.publishDate).format('MM/DD/YYYY')}</td>
                                            </tr>
                                        );
                                        };
                                        return (
                                            <Fragment key={parent.id}>
                                                {renderRow(parent)}
                                                {this.state.expandedParents[parent.id] && parent.children.map((child) => renderRow(child, true))}
                                            </Fragment>
                                        );})
                                    }
                                </tbody>
                            </Table>
                            <div>
                                <PaginationNumbering
                                    currentPage={currentPageNumber}
                                    returnPagenumber={this.handlePageNumberChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                            </div>
                        </Show>
                    </Show>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedCountry: state.adminUser.adminUser.selectedCountry,
});

const DashboardSurvey = connect(mapStateToProps)(DashboardSurveyComponent);
export { DashboardSurvey };
